import { render, staticRenderFns } from "./BtnInserirAcaoPlanoTrabalho.vue?vue&type=template&id=32e089e0"
import script from "./BtnInserirAcaoPlanoTrabalho.vue?vue&type=script&lang=js"
export * from "./BtnInserirAcaoPlanoTrabalho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports